import React from "react"
import PropTypes from "prop-types"
import { CrossIcon } from "components"
import { Radium } from "higher-order-components"
import { noop, get } from "utils"

const THEMES = { LIGHT: "light", DARK: "dark" }
const getBase = get("base")
const getSvg = get("svg")

const CloseButton = ({
  onClick, style, dataTest, styleName
}) => (
  <a
    style={[closeButtonStyles.base, getBase(themeStyles[styleName]), getBase(style) || style]}
    onClick={onClick}
    data-test={dataTest}>
    <CrossIcon
      style={{
        ...closeButtonStyles.svg,
        ...getSvg(themeStyles[styleName]),
        ...getSvg(style)
      }} />
  </a>
)

CloseButton.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  styleName: PropTypes.oneOf(Object.keys(THEMES).map(key => THEMES[key])),
  dataTest: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
}

CloseButton.defaultProps = {
  onClick: noop,
  style: {},
  styleName: THEMES.DARK,
  dataTest: false
}

CloseButton.THEMES = CloseButton.STYLE_NAMES = { ...THEMES }

export default Radium(CloseButton)

const themeStyles = {
  [THEMES.DARK]: {
    svg: {
      fill: "#101010"
    }
  },
  [THEMES.LIGHT]: {
    svg: {
      fill: "#fff"
    }
  }
}

const closeButtonStyles = {
  base: {
    position: "absolute",
    width: "25px",
    height: "25px",
    right: "1.5em",
    top: "1.5em",
    cursor: "pointer",
    textDecoration: "none",
    border: 0,
    zIndex: 20
  },
  svg: {
    display: "block",
    width: "100%",
    height: "100%"
  }
}



// WEBPACK FOOTER //
// ./src/components/close-button/index.jsx